import { useCallback } from "react";
import { useAppContext } from "../../Contexts";
import { fetchBaseJsonAll } from "../../Api/ado.api";
import { useAsyncResult } from "../UseAsyncResult";

/**
 * Hook to fetch base json for all extensions.
 * @returns The base JSON array data or an empty array if not found.
 */
export function useFetchBaseJsonConfigAll() {
  const { setError } = useAppContext();

  const func = useCallback(async (_disposable, _force) => {
    let baseJson;

    try {
      const response = await fetchBaseJsonAll();
      baseJson = response;
    } catch (error) {
      console.error("Failed to fetch base JSON:", error);
    }

    if (!baseJson) {
      return [];
    }
    return baseJson;
  }, []);

  return useAsyncResult({
    func,
    setError,
  });
}
